export const teamsEndpoint = 'GetCurrentUserTeamsOptions';
export const teamsOptionsForOrgUnitEndpoint = 'GetOrgUnitTeamsOptions';
export const activitiesEndpoint = 'GetActivitiesOptions';
export const activitiesForTreatmentInstance = 'GetActivitiesOptionsForTreatmentInstance';
export const activitiesOptionsForReferralEndpoint = 'GetActivityOptionsByReferralId';
export const treatmentsByReferralIdEndpoint = referralId => `GetTreatmentsByReferralId?referralId=${referralId}`;
export const activityTypesEndpoint = visitType => `GetActivityTypesByVisitType?visitType=${visitType}`;
export const skillsEndpoint = 'GetSkillsOptions';
export const bandsEndpoint = 'GetBandsOptions';
export const ragsEndpoint = 'GetRagStatusOptions';
export const cliniciansEndpoint = 'GetCliniciansOptions';
export const rosteredCliniciansEndpoint = 'GetRosteredCliniciansByTeamIdOptions';
export const cliniciansForUserEndpoint = 'GetCliniciansOptionsForUser';
export const cliniciansAssignedToCurrentUserEndpoint = 'GetCurrentUserClinicians';
export const cancellationReasonsEndpoint = 'GetCancellationReasonsOptions';
export const cancellationReasonsAllEndpoint = 'GetCancellationReasonsOptionsAll';
export const movedReasonsEndpoint = 'GetMovedReasonsOptions';
export const notDoneReasonsEndpoint = 'GetNotDoneReasonsOptions';
export const locationTypesEndpoint = 'GetLocationTypesOptions';
export const referenceCodesEndpoint = 'GetReferenceCodesOptions';
export const referralPrioritiesEndpoint = 'GetReferralPrioritiesOptions';
export const referralSourcesEndpoint = 'GetReferralSourcesOptions';
export const referralServiceEndpoint = 'GetReferralServiceOptions';
export const activityVarianceEndpoint = activityId => `GetActivityVarianceIntervals?activityId=${activityId}`;
export const activityVariancesOptionsEndpoint = activityId => `GetActivityVariancesOptions?activityId=${activityId}`;
export const getActivitiesEndpointForTreatmentInstance = treatmentInstanceId =>
  `${activitiesForTreatmentInstance}?treatmentInstanceId=${treatmentInstanceId}`;
export const getActivitiesEndpointUpToBand = band => `${activitiesEndpoint}?MaxBand=${band}`;
export const getActivitiesEndpointForVisitType = visitType => `${activitiesEndpoint}?VisitType=${visitType}`;
export const orgUnitsEndpoint = type => `${teamsEndpoint}?type=${type}`;
export const nonPatientActiviesTypesEndpoint = 'GetNonPatientActivityTypesOptions';
export const referralPrioritesEndPoint = 'GetReferralPriorities';
export const referralSourcesEndPoint = 'GetReferralSources';
export const referralServicesEndPoint = 'GetReferralServices';
export const mileageCapEndpoint = 'GetCliniciansMileageCap';
export const autoAllocateWeightingsEndpoint = 'GetAutoAllocateWeightings';
export const cancellingPartiesEndPoint = 'GetCancellingParties';
export const outcomeCodesEndpoint = 'GetOutcomeCodesOptions';
export const getPreferredCliniciansEndpointForTreatment = treatmentId =>
  `GetPreferredClinicianByTreatmentId?treatmentId=${treatmentId}`;
